import { render } from "./GenericVideoModal.vue?vue&type=template&id=58126162"
import script from "./GenericVideoModal.vue?vue&type=script&lang=js"
export * from "./GenericVideoModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__